const SET_LANG = 'SET_LANG';
export default SET_LANG;



// WEBPACK FOOTER //
// ./src/store/modules/i18n/types.js